import { useState } from 'react'
import axios from 'axios'
import { apiURL } from './ApiConfig'

export function usePost() {
    const [ response, setResponse ] = useState(null)
    const [ loading,  setLoading  ] = useState(false)
    const [ error,    setError    ] = useState(null)
    axios.defaults.baseURL = apiURL

    const post = async (data) => {
        setLoading(true)
        try {
            const resp = await axios.post(apiURL, data)
            setResponse(resp.data)
        } catch (err) {
            setError(err)
        } finally {
            setLoading(false)
        }
    }

    return { response, loading, error, post }
}
